<!-- eslint-disable max-len -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="-6 -6 50 50" fill="none">
    <path
      d="M11.0059 4.1394L11.0974 8.59643L13.1081 26.1489V33.8606H24.9017V26.1488L26.907 8.64229L26.9123 8.59643L27.0039 4.1394H11.0059ZM22.8204 31.8342H21.0568C20.8915 30.8758 20.036 30.1455 19.0049 30.1455C17.9738 30.1455 17.1183 30.8759 16.953 31.8342H15.1893V27.1058H22.8204V31.8342ZM22.9301 25.0793H15.0797L13.3774 10.2187H24.6324L22.9301 25.0793ZM24.8389 8.19229H13.1708L13.1291 6.16585H24.8807L24.8389 8.19229Z"
      :fill="pathFill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    pathFill: {
      type: String,
      default: '#FFFFFF',
    },
  },
};
</script>
